<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )

    receipt(ref="receipt")
</template>

<script>
import receiptMixin from '../../mixins/receipt';
export default {
    mixins: [receiptMixin],

    data() {
        var that = this;

        return {
            tableName: 'VOIDER_ORDERS',
            columns: [
                'voided_at',
                'receipt_number',
                'product',
                'price',
                'table_name',
                'quantity',
                'voider',
                'void_reason',
                'cashier',
            ],
            options: {
                headings: {
                    receipt_number: 'Receipt No.',
                    table_name: 'Table',
                    voider: 'Voided by',
                },
                useReportFilter: true,
                texts: {
                    title: 'Voided Orders',
                    description: 'Shows list of voided orders',
                },
                columnsClasses: {
                    table_name: 'text-center',
                    price: 'text-center',
                    quantity: 'text-center',
                },
                pdf_url: Laroute.route(
                    'franchise.report.voidedsales.voided_orders_export',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.voidedsales.voided_orders_export',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.voidedsales.voided_orders_export',
                    { type: 'XLSX' },
                ),
                templates: {
                    receipt_number: (h, row, col) => {
                        return this.receiptNumberFormat(row);
                    },

                    voided_at: (h, row, col) => {
                        return this.receiptDateFormat(row.voided_at);
                    },
                    price: (h, row) => {
                        return numeral(parseFloat(row.price)).format();
                    },
                },
                rowClickCallback: row => {
                    this.showReceipt(row.id);
                },
                rowClassCallback: row => {
                    return 'pointer';
                },
            },
        };
    },

    computed: {
        datatableUrl() {
            return Laroute.route('franchise.report.voidedsales.voided_orders');
        },
    },

    methods: {
        showReceipt(transaction_id) {
            this.$refs.receipt.$emit('show-receipt', transaction_id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/voided-orders.vue